export default {
    // Timecode Picker
    "Pick player time": "Sélectionner le temps du player",
    "hh:mm:ss": "hh:mm:ss",

}